// @generated by protoc-gen-es v2.2.3 with parameter "target=ts,import_extension=none"
// @generated from file v1/org/org_types.proto (package api.v1.org, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_type_latlng } from "../../google/type/latlng_pb";
import { file_v1_common_common_types } from "../common/common_types_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/org/org_types.proto.
 */
export const file_v1_org_org_types: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_type_latlng, file_v1_common_common_types]);

/**
 * Image represents an image entity
 *
 * @generated from message api.v1.org.Image
 */
export type Image = Message<"api.v1.org.Image"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: string usage = 3;
   */
  usage: string;

  /**
   * @generated from field: optional string alt_text = 4;
   */
  altText?: string;

  /**
   * @generated from field: optional int32 position = 5;
   */
  position?: number;

  /**
   * @generated from field: optional string storage_path = 6;
   */
  storagePath?: string;

  /**
   * @generated from field: optional int32 width = 7;
   */
  width?: number;

  /**
   * @generated from field: optional int32 height = 8;
   */
  height?: number;

  /**
   * @generated from field: optional string mime_type = 9;
   */
  mimeType?: string;

  /**
   * @generated from field: optional int64 size_bytes = 10;
   */
  sizeBytes?: bigint;

  /**
   * @generated from field: string content_hash = 11;
   */
  contentHash: string;
};

/**
 * Describes the message api.v1.org.Image.
 * Use `create(ImageSchema)` to create a new message.
 */
export const ImageSchema: GenMessage<Image> = /*@__PURE__*/
  messageDesc(file_v1_org_org_types, 0);

/**
 * Category represents an organization type/category
 *
 * @generated from message api.v1.org.Category
 */
export type Category = Message<"api.v1.org.Category"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string icon = 4;
   */
  icon: string;

  /**
   * @generated from field: string code = 5;
   */
  code: string;
};

/**
 * Describes the message api.v1.org.Category.
 * Use `create(CategorySchema)` to create a new message.
 */
export const CategorySchema: GenMessage<Category> = /*@__PURE__*/
  messageDesc(file_v1_org_org_types, 1);

/**
 * PublicLink represents a public link for an organization
 *
 * @generated from message api.v1.org.PublicLink
 */
export type PublicLink = Message<"api.v1.org.PublicLink"> & {
  /**
   * @generated from field: string display_name = 1;
   */
  displayName: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;
};

/**
 * Describes the message api.v1.org.PublicLink.
 * Use `create(PublicLinkSchema)` to create a new message.
 */
export const PublicLinkSchema: GenMessage<PublicLink> = /*@__PURE__*/
  messageDesc(file_v1_org_org_types, 2);

/**
 * Org represents an organization
 *
 * @generated from message api.v1.org.Org
 */
export type Org = Message<"api.v1.org.Org"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * Basic org information
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string display_name = 4;
   */
  displayName: string;

  /**
   * @generated from field: string bio = 5;
   */
  bio: string;

  /**
   * @generated from field: repeated api.v1.org.Image images = 6;
   */
  images: Image[];

  /**
   * @generated from field: optional string website = 7;
   */
  website?: string;

  /**
   * @generated from field: string email = 8;
   */
  email: string;

  /**
   * @generated from field: string phone = 9;
   */
  phone: string;

  /**
   * @generated from field: string owner_id = 10;
   */
  ownerId: string;

  /**
   * Status and category
   *
   * @generated from field: api.v1.org.OrgStatus status = 11;
   */
  status: OrgStatus;

  /**
   * @generated from field: api.v1.org.Category category = 12;
   */
  category?: Category;

  /**
   * Timestamps
   *
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 14;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 15;
   */
  deletedAt?: Timestamp;
};

/**
 * Describes the message api.v1.org.Org.
 * Use `create(OrgSchema)` to create a new message.
 */
export const OrgSchema: GenMessage<Org> = /*@__PURE__*/
  messageDesc(file_v1_org_org_types, 3);

/**
 * OrgPublicProfile represents an organization's public profile
 *
 * @generated from message api.v1.org.OrgPublicProfile
 */
export type OrgPublicProfile = Message<"api.v1.org.OrgPublicProfile"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * @generated from field: optional string bio = 4;
   */
  bio?: string;

  /**
   * @generated from field: repeated api.v1.org.Image images = 5;
   */
  images: Image[];

  /**
   * @generated from field: optional string public_email = 6;
   */
  publicEmail?: string;

  /**
   * @generated from field: optional string public_phone = 7;
   */
  publicPhone?: string;

  /**
   * @generated from field: optional string public_website = 8;
   */
  publicWebsite?: string;

  /**
   * @generated from field: optional string public_address = 9;
   */
  publicAddress?: string;

  /**
   * @generated from field: optional string public_address_place_id = 10;
   */
  publicAddressPlaceId?: string;

  /**
   * @generated from field: optional double public_address_latitude = 11;
   */
  publicAddressLatitude?: number;

  /**
   * @generated from field: optional double public_address_longitude = 12;
   */
  publicAddressLongitude?: number;

  /**
   * @generated from field: optional string public_address_postal_code = 13;
   */
  publicAddressPostalCode?: string;

  /**
   * @generated from field: api.v1.org.Category category = 14;
   */
  category?: Category;

  /**
   * @generated from field: repeated api.v1.org.PublicLink public_links = 15;
   */
  publicLinks: PublicLink[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 16;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 17;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 18;
   */
  deletedAt?: Timestamp;

  /**
   * Location Information
   *
   * How the organization operates regarding location
   *
   * @generated from field: optional api.v1.org.LocationType location_type = 19;
   */
  locationType?: LocationType;

  /**
   * Description of the service area (for service area type)
   *
   * @generated from field: optional string service_area_description = 20;
   */
  serviceAreaDescription?: string;

  /**
   * Radius in kilometers for service area
   *
   * @generated from field: optional double service_area_radius_km = 21;
   */
  serviceAreaRadiusKm?: number;

  /**
   * Postal code for service area
   *
   * @generated from field: optional string service_area_postal_code = 22;
   */
  serviceAreaPostalCode?: string;

  /**
   * Latitude for service area
   *
   * @generated from field: optional double service_area_latitude = 23;
   */
  serviceAreaLatitude?: number;

  /**
   * Longitude for service area
   *
   * @generated from field: optional double service_area_longitude = 24;
   */
  serviceAreaLongitude?: number;

  /**
   * Place ID for service area
   *
   * @generated from field: optional string service_area_place_id = 25;
   */
  serviceAreaPlaceId?: string;
};

/**
 * Describes the message api.v1.org.OrgPublicProfile.
 * Use `create(OrgPublicProfileSchema)` to create a new message.
 */
export const OrgPublicProfileSchema: GenMessage<OrgPublicProfile> = /*@__PURE__*/
  messageDesc(file_v1_org_org_types, 4);

/**
 * FollowerProfile represents a user following an organization
 *
 * @generated from message api.v1.org.FollowerProfile
 */
export type FollowerProfile = Message<"api.v1.org.FollowerProfile"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: google.protobuf.Timestamp followed_at = 3;
   */
  followedAt?: Timestamp;
};

/**
 * Describes the message api.v1.org.FollowerProfile.
 * Use `create(FollowerProfileSchema)` to create a new message.
 */
export const FollowerProfileSchema: GenMessage<FollowerProfile> = /*@__PURE__*/
  messageDesc(file_v1_org_org_types, 5);

/**
 * FollowingOrgProfile represents an organization that a user follows
 *
 * @generated from message api.v1.org.FollowingOrgProfile
 */
export type FollowingOrgProfile = Message<"api.v1.org.FollowingOrgProfile"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp followed_at = 5;
   */
  followedAt?: Timestamp;
};

/**
 * Describes the message api.v1.org.FollowingOrgProfile.
 * Use `create(FollowingOrgProfileSchema)` to create a new message.
 */
export const FollowingOrgProfileSchema: GenMessage<FollowingOrgProfile> = /*@__PURE__*/
  messageDesc(file_v1_org_org_types, 6);

/**
 * Distance and service area information for organization results
 *
 * @generated from message api.v1.org.OrgDistanceInfo
 */
export type OrgDistanceInfo = Message<"api.v1.org.OrgDistanceInfo"> & {
  /**
   * @generated from field: double distance_km = 1;
   */
  distanceKm: number;

  /**
   * @generated from field: double distance_miles = 2;
   */
  distanceMiles: number;

  /**
   * "2.3 miles" or "5.1 km"
   *
   * @generated from field: string formatted_distance = 3;
   */
  formattedDistance: string;

  /**
   * For service area organizations
   *
   * @generated from field: bool serves_user_location = 4;
   */
  servesUserLocation: boolean;

  /**
   * "Serves your area" or "2km outside service area"
   *
   * @generated from field: optional string service_coverage_note = 5;
   */
  serviceCoverageNote?: string;
};

/**
 * Describes the message api.v1.org.OrgDistanceInfo.
 * Use `create(OrgDistanceInfoSchema)` to create a new message.
 */
export const OrgDistanceInfoSchema: GenMessage<OrgDistanceInfo> = /*@__PURE__*/
  messageDesc(file_v1_org_org_types, 7);

/**
 * OrganizationWithDistance represents an organization with distance information
 *
 * @generated from message api.v1.org.OrganizationWithDistance
 */
export type OrganizationWithDistance = Message<"api.v1.org.OrganizationWithDistance"> & {
  /**
   * @generated from field: api.v1.org.OrgPublicProfile organization = 1;
   */
  organization?: OrgPublicProfile;

  /**
   * @generated from field: double distance_km = 2;
   */
  distanceKm: number;

  /**
   * @generated from field: double distance_miles = 3;
   */
  distanceMiles: number;

  /**
   * "2.3 miles" or "5.1 km"
   *
   * @generated from field: string formatted_distance = 4;
   */
  formattedDistance: string;

  /**
   * For service area organizations
   *
   * @generated from field: bool serves_user_location = 5;
   */
  servesUserLocation: boolean;

  /**
   * "Serves your area" or "2km outside service area"
   *
   * @generated from field: optional string service_coverage_note = 6;
   */
  serviceCoverageNote?: string;
};

/**
 * Describes the message api.v1.org.OrganizationWithDistance.
 * Use `create(OrganizationWithDistanceSchema)` to create a new message.
 */
export const OrganizationWithDistanceSchema: GenMessage<OrganizationWithDistance> = /*@__PURE__*/
  messageDesc(file_v1_org_org_types, 8);

/**
 * Organization result with optional distance/service info for community searches
 *
 * @generated from message api.v1.org.OrgSearchResult
 */
export type OrgSearchResult = Message<"api.v1.org.OrgSearchResult"> & {
  /**
   * @generated from field: api.v1.org.OrgPublicProfile organization = 1;
   */
  organization?: OrgPublicProfile;

  /**
   * Only populated for COMMUNITY mode
   *
   * @generated from field: optional api.v1.org.OrgDistanceInfo distance_info = 2;
   */
  distanceInfo?: OrgDistanceInfo;
};

/**
 * Describes the message api.v1.org.OrgSearchResult.
 * Use `create(OrgSearchResultSchema)` to create a new message.
 */
export const OrgSearchResultSchema: GenMessage<OrgSearchResult> = /*@__PURE__*/
  messageDesc(file_v1_org_org_types, 9);

/**
 * @generated from enum api.v1.org.OrgStatus
 */
export enum OrgStatus {
  /**
   * @generated from enum value: ORG_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ORG_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: ORG_STATUS_ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * @generated from enum value: ORG_STATUS_SUSPENDED = 3;
   */
  SUSPENDED = 3,

  /**
   * @generated from enum value: ORG_STATUS_DELETED = 4;
   */
  DELETED = 4,
}

/**
 * Describes the enum api.v1.org.OrgStatus.
 */
export const OrgStatusSchema: GenEnum<OrgStatus> = /*@__PURE__*/
  enumDesc(file_v1_org_org_types, 0);

/**
 * LocationType defines how an organization operates regarding location
 *
 * @generated from enum api.v1.org.LocationType
 */
export enum LocationType {
  /**
   * @generated from enum value: LOCATION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Organization has a physical address
   *
   * @generated from enum value: LOCATION_TYPE_PHYSICAL_ADDRESS = 1;
   */
  PHYSICAL_ADDRESS = 1,

  /**
   * Organization serves a geographic area
   *
   * @generated from enum value: LOCATION_TYPE_SERVICE_AREA = 2;
   */
  SERVICE_AREA = 2,
}

/**
 * Describes the enum api.v1.org.LocationType.
 */
export const LocationTypeSchema: GenEnum<LocationType> = /*@__PURE__*/
  enumDesc(file_v1_org_org_types, 1);

/**
 * Location search mode for unified organization search
 *
 * @generated from enum api.v1.org.LocationSearchMode
 */
export enum LocationSearchMode {
  /**
   * @generated from enum value: LOCATION_SEARCH_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Search within radius of specific location
   *
   * @generated from enum value: LOCATION_SEARCH_MODE_COMMUNITY = 1;
   */
  COMMUNITY = 1,

  /**
   * Search everywhere without location restrictions
   *
   * @generated from enum value: LOCATION_SEARCH_MODE_BEYOND = 2;
   */
  BEYOND = 2,
}

/**
 * Describes the enum api.v1.org.LocationSearchMode.
 */
export const LocationSearchModeSchema: GenEnum<LocationSearchMode> = /*@__PURE__*/
  enumDesc(file_v1_org_org_types, 2);

/**
 * Sort options for unified organization search
 *
 * @generated from enum api.v1.org.SearchSortBy
 */
export enum SearchSortBy {
  /**
   * @generated from enum value: SEARCH_SORT_BY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Closest first (only for COMMUNITY mode)
   *
   * @generated from enum value: SEARCH_SORT_BY_DISTANCE = 1;
   */
  DISTANCE = 1,

  /**
   * Most popular/trending
   *
   * @generated from enum value: SEARCH_SORT_BY_TRENDING = 2;
   */
  TRENDING = 2,

  /**
   * Recently created/updated
   *
   * @generated from enum value: SEARCH_SORT_BY_RECENT = 3;
   */
  RECENT = 3,

  /**
   * Most followed/reviewed
   *
   * @generated from enum value: SEARCH_SORT_BY_POPULAR = 4;
   */
  POPULAR = 4,

  /**
   * Alphabetical by display_name
   *
   * @generated from enum value: SEARCH_SORT_BY_NAME = 5;
   */
  NAME = 5,
}

/**
 * Describes the enum api.v1.org.SearchSortBy.
 */
export const SearchSortBySchema: GenEnum<SearchSortBy> = /*@__PURE__*/
  enumDesc(file_v1_org_org_types, 3);

/**
 * Service area search sorting options
 *
 * @generated from enum api.v1.org.ServiceAreaSortBy
 */
export enum ServiceAreaSortBy {
  /**
   * @generated from enum value: SERVICE_AREA_SORT_BY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Closest first
   *
   * @generated from enum value: SERVICE_AREA_SORT_BY_DISTANCE = 1;
   */
  DISTANCE = 1,

  /**
   * Best match for location and query
   *
   * @generated from enum value: SERVICE_AREA_SORT_BY_RELEVANCE = 2;
   */
  RELEVANCE = 2,

  /**
   * Most followed/reviewed first
   *
   * @generated from enum value: SERVICE_AREA_SORT_BY_POPULAR = 3;
   */
  POPULAR = 3,

  /**
   * Recently added/updated first
   *
   * @generated from enum value: SERVICE_AREA_SORT_BY_RECENT = 4;
   */
  RECENT = 4,
}

/**
 * Describes the enum api.v1.org.ServiceAreaSortBy.
 */
export const ServiceAreaSortBySchema: GenEnum<ServiceAreaSortBy> = /*@__PURE__*/
  enumDesc(file_v1_org_org_types, 4);

